import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";
import { Header, Grid } from "semantic-ui-react";

import { SecondaryCaseStatus } from "@teamprevent/common/workAdjustment/models";
import { SendDocumentsToAssociate } from "@teamprevent/common/shareDocuments/components/SendDocumentsToAssociate";
import { ShareDocumentsMessageDto } from "@teamprevent/common/shareDocuments/models";

import { ApplicationState } from "../../../../../applicationState";
import { sendDocumentsToAssociate } from "../../../../../shareDocuments/actions";

import { HrrcUseOnlyButton } from "./HrrcUseOnlyButton";

interface OwnProps {
    workAdjustmentCaseId: string;
}

const WorkAdjustmentCaseDetails: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const dispatch = useDispatch();

    const workAdjustmentCase = useSelector((state: ApplicationState) => state.ohCases?.find(c => c.id === props.workAdjustmentCaseId));
    const secondaryCaseStatus = workAdjustmentCase?.secondaryCaseStatus;
    const isInUpdatedStatus = secondaryCaseStatus === SecondaryCaseStatus.Updated;

    const onSendDocumentsToAssociate = async (model: ShareDocumentsMessageDto) => {
        dispatch(sendDocumentsToAssociate(props.workAdjustmentCaseId, model));
    };

    return (
        <Grid columns="equal" stackable>
            <Grid.Column>
                <Header as="h4">Status: {secondaryCaseStatus ?? ""}</Header>
            </Grid.Column>
            <Grid.Column textAlign="right">
                <SendDocumentsToAssociate
                    employeeRecordId={workAdjustmentCase.employeeRecordId}
                    fileApiUrl={`/api/shareDocuments/${props.workAdjustmentCaseId}/document`}
                    onSubmit={onSendDocumentsToAssociate}
                />
                {isInUpdatedStatus && <HrrcUseOnlyButton workAdjustmentCase={workAdjustmentCase} />}
            </Grid.Column>
        </Grid>
    );
};

export { WorkAdjustmentCaseDetails };
